import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { processFetchedResult } from '../utils/response-processor';

import type { Response, RequestProps, RelatedServiceSuccessResponse } from '../types';

export function* fetchRelatedServices({ productId, regionCode }: RequestProps, options: ApiRequestConfig) {
  const data = yield* get<RelatedServiceSuccessResponse>(
    'get-related-services',
    { productId, regionCode },
    {
      ...options,
    },
  );

  return {
    relatedServices: processFetchedResult(data as Response),
    baseEntityIds: 'baseEntityIds' in data ? data.baseEntityIds : [],
  };
}
